<template>
	<v-container>
		<div v-if="feedback == 0">
			<v-row class="contentRow">
				<v-col cols="12" align="center">
					<v-btn outlined class="ma-2 white--text" color="primary" @click="commentBoxOpen = true" v-if="!isFeedbackGiven">Give your feedback</v-btn>
					<!--<v-btn dark color="orangeButton" class="ma-2" @click="getFreeAcc()">GET A FREE TRAIL</v-btn>-->
				</v-col>
			</v-row>
			<v-row class="contentRow">
				<v-col>
					<v-avatar
						class="float-left d-none d-md-block"
						style="position:absolute;"
						color="grey"
						size="85"
					>
						<v-img v-if="logo" width="300" :src="logo" />
						<v-icon v-else size="43">fas fa-building</v-icon>
					</v-avatar>
					<h1>
						<span
							class="error--text"
							v-if="
								audit &&
									audit.expiryDate &&
									$moment(audit.expiryDate).isBefore($moment())
							"
							>(Expired) </span
						>Flow-Down Audit {{ templateName }}
					</h1>
					<span
						v-if="audit && typeof audit.status !== 'undefined'"
						class="text-center"
						><p>Sent to {{ senderName }}</p></span
					>
					<span v-else class="text-center"
						><p>Audit from {{ recipientName }}</p></span
					>
				</v-col>
			</v-row>
			<v-row class="contentRow grey" v-if="replacing">
				<v-col>
					<v-icon dark left class="mb-2">fas fa-info-circle</v-icon>
					<p class="white--text text-h5">
						This audit replaced another audit. <br />
						The edited fields are highlighted below.
					</p>
					<v-btn
						small
						light
						:to="{ name: `Audit Details`, params: { id: replacing } }"
						target="_blank"
						>View it here.</v-btn
					>
				</v-col>
			</v-row>
			<v-row class="contentRow warning" v-if="replacedBy">
				<v-col>
					<h2 class="white--text">
						<v-icon dark left>fas fa-exclamation-triangle</v-icon>This audit was
						replaced by another audit. <br />
						<p><i>See what was edited below</i></p>
						<v-btn
							light
							:to="{ name: `Audit Details`, params: { id: replacedBy } }"
							target="_blank"
							>View it here.</v-btn
						>
					</h2>
				</v-col>
			</v-row>
			<div v-for="(question, index) in auditData" :key="index">
				<v-row v-if="index == 0"></v-row>
				<v-row
					class="my-13"
					v-else-if="shouldDisplay(question) && question.type == 'spacer'"
				></v-row>
				<v-row
					v-else-if="shouldDisplay(question) && question.type == 'title'"
					class="contentRow primary"
				>
					<v-col cols="6" class="mr-auto white--text">
						<h2>{{ question.name }}</h2>
					</v-col>
				</v-row>
				<v-row
					no-gutters
					v-else-if="shouldDisplay(question) && question.type == 'attachment'"
					class="contentRow secondary"
					dark
				>
					<v-col cols="6" class="mr-auto white--text">
						<h2 class="mb-10">
							<v-icon dark left>fas fa-paperclip</v-icon>{{ question.name }}
						</h2>
					</v-col>
					<!--'File uplad' text field-->
					<v-col cols="12" class="white--text">
						<file-uploader
							:value="question.fileID"
							:readonly="true"
							:disabled="true"
							:dark="true"
							:name="question.name"
						/>
					</v-col>
				</v-row>
				<v-row class="contentRow" v-else-if="shouldDisplay(question)">
					<v-col>
						<h4 class="primary--text">
							{{ question.name
							}}<sup
								><v-icon v-if="question.Required" color="error" right x-small
									>fa-asterisk</v-icon
								></sup
							>
							<v-chip
								v-if="question.previousAnswer"
								class="ml-2"
								label
								small
								color="warning"
							>
								Edited
							</v-chip>
						</h4>
						<br />
						<p v-if="question.type == 'file'">
							<file-uploader
								:value="question.answer"
								:readonly="true"
								:disabled="true"
								:dark="true"
								:name="question.name"
							/>
							<v-alert
								v-if="question.previousAnswer"
								icon="fas fa-history"
								border="left"
								color="blue-grey"
								light
								dense
								outlined
								text
							>
								<b>Previous Answer:</b><br />
								<file-uploader
									:value="question.previousAnswer"
									:readonly="true"
									:disabled="true"
									:dark="true"
									:name="question.name"
								/>
							</v-alert>
						</p>
						<p v-else-if="!question.answer">
							<i>This question was not answered</i>
						</p>
						<p v-else>{{ question.answer }}</p>
						<v-alert
							v-if="question.previousAnswer && question.type != 'file'"
							icon="fas fa-history"
							border="left"
							color="blue-grey"
							dark
							dense
							outlined
							text
						>
							<b>Previous Answer:</b><br />{{ question.previousAnswer }}</v-alert
						>
					</v-col>
				</v-row>
			</div>
			<!-- <v-row
				class="contentRow darkColor--text"
				v-if="
					audit &&
						audit.isSender == true &&
						audit.allowFlowDown == true &&
						$accessToOperation('AFD', 'R')
				"
			>
				<v-col>
					<h2>
						Audit Flow Down<v-icon right>fas fa-clone</v-icon
						><v-icon right>fas fa-turn-down</v-icon>
					</h2>
					<p>
						Duplicate this audit to send to your suppliers. Clicking the button
						below will create a new Audit Template based on this Audit. The
						Auditor will be able to see how many people you have forwarded this
						audit to.
					</p>
					<v-btn @click="flowDown"
						>Flow Down <v-icon right>fas fa-up-right-from-square</v-icon></v-btn
					>
				</v-col>
			</v-row> -->
			<!--Flow down view for auditor-->
			<v-row
				class="contentRow darkColor--text"
				v-if="
					audit &&
						audit.allowFlowDown == true &&
						typeof audit.retransmissions != 'undefined' &&
						$accessToRoute('/auditflowdown/flowdowntemplates' && typeof audit.status !== 'undefined')
				"
			>
				<v-col>
					<h2>
						Audit Flow Down<v-icon right>fas fa-turn-down</v-icon>
					</h2>
					<p>
						This audit can be duplicated by your suppliers, to be sent to their suppliers.
					</p>
					<p>
						The Audit has 
						<span v-if="audit.retransmissions > 0">
							been re-transmitted by <b>{{audit.senderName}}</b>, and filled out, <b>{{audit.retransmissions}}</b> times.
							<br>
							The longest flow down chain is <b>{{audit.retransmission_depth}}</b> steps.
						</span>
						<span v-else>not been re-transmitted yet by <b>{{audit.senderName}}</b>.</span>
						
					</p>
				</v-col>
			</v-row>
			<v-row class="contentRow" v-if="retransmissionsHierarchy">
			<v-col>
				<h2>Audit Hierarchy</h2>
				<div>
					<!-- Render the hierarchy dynamically -->
					<div v-html="renderHierarchy(retransmissionsHierarchy)"></div>
				</div>
			</v-col>
		</v-row>
		<v-row
				class="contentRow white--text"
				v-bind:class="{
					primary: audit.status == 0,
					success: audit.status == 1,
					warning: audit.status == 2,
					error: audit.status == 3
				}"
				v-if="audit && typeof audit.status !== 'undefined'"
			>
				<v-col>
					<h2>Audit is {{ status(audit.status) }}.</h2>
					<p>{{ audit.statusComment }}</p>
				</v-col>
			</v-row>
			<v-row
				class="contentRow"
				v-if="audit && typeof audit.status !== 'undefined'"
			>
				<v-col>
					<h2>Expiry Date</h2>
				</v-col>
				<v-col justify-center cols="12" v-if="audit.expiryDate > 0">
					<p
						class="error--text"
						v-if="$moment(audit.expiryDate).isBefore($moment())"
					>
						Audit Expired {{ audit.expiryDate | moment("DD.MM.YYYY") }}
					</p>
					<p v-else>
						Audit will expire on {{ audit.expiryDate | moment("DD.MM.YYYY")
						}}<br /><i>You will be notified 60 days before the audit expires.</i>
					</p>
					<v-menu
						v-model="expiryDateMenu"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn v-bind="attrs" v-on="on" outlined dense
								>Change Expiry Date</v-btn
							>
						</template>
						<v-date-picker
							label="Expiry Date"
							@change="v => setNewExpiryDate(v)"
							color="primary"
						></v-date-picker>
					</v-menu>
				</v-col>
				<v-col justify-center cols="12" v-else>
					<p>Audit does not have an expiry date.</p>
					<v-menu
						v-model="expiryDateMenu"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn v-bind="attrs" v-on="on" outlined dense
								>Set Expiry Date</v-btn
							>
						</template>
						<v-date-picker
							label="Expiry Date"
							@change="v => setNewExpiryDate(v)"
							color="primary"
						></v-date-picker>
					</v-menu>
				</v-col>
			</v-row>
			<v-row
				v-if="
					audit && audit.history !== null && checklist && checklist.length > 0
				"
				class="contentRow"
			>
				<v-col>
					<h2>Auditor Checklist</h2>
				</v-col>
				<v-col cols="12" v-for="(item, index) in checklist" :key="item">
					<v-row>
						<v-checkbox v-model="checklistAnswers[index]" :label="item">
						</v-checkbox>
					</v-row>
				</v-col>
			</v-row>
			<v-row
				class="contentRow"
				v-if="audit && typeof audit.status !== 'undefined'"
			>
				<v-col>
					<h2>Change Status</h2>
				</v-col>
				<v-col cols="12">
					<v-textarea
						name="comments"
						v-model="comment"
						outlined
						auto-grow
						placeholder="Add your comment here..."
					></v-textarea>
				</v-col>
				<v-col justify-center cols="12">
					<v-btn class="ma-2" color="primary" v-on:click="setStatus(1)" :outlined="!isButtonClicked(1)"
						>Approve Audit</v-btn
					>
					<v-btn class="ma-2" color="warning" v-on:click="setStatus(2)" :outlined="!isButtonClicked(2)"
						>Conditionally Approve Audit</v-btn
					>
					<v-btn class="ma-2 denybutton" color="red" v-on:click="setStatus(3)" :outlined="!isButtonClicked(3)"
						>Deny Audit</v-btn
					>
				</v-col>
			</v-row>
			<v-dialog v-model="confirmationDialog" max-width="500px">
				<v-card>
					<v-card-title>Are you sure you want to change the status?</v-card-title>
					<v-card-action >
						<v-btn color="primary" class="my-5 mx-5" @click="confirmStatusChange" outlined>Change</v-btn>
						<v-btn color="error" @click="cancelStatusChange" outlined>Cancel</v-btn>
					</v-card-action>
				</v-card>
			</v-dialog>
			<v-row
				class="contentRow"
				v-if="
					audit &&
						typeof audit.status !== 'undefined' &&
						audit.editRequest == null
				"
			>
				<v-col cols="12">
					<h2>Request edit</h2>
				</v-col>
				<v-col cols="12">
					<v-textarea
						name="requestEditComment"
						v-model="requestEditComment"
						placeholder="Add your comments here..."
						outlined
						auto-grow
					></v-textarea>
				</v-col>
				<v-col justify-center cols="12">
					<v-alert dense color="primary" class="mt-5" type="info">
						Ask the submitter to resubmit this audit with modified answers
					</v-alert>
					<v-btn
						:disabled="!requestEditComment"
						class="mt-2"
						color="primary"
						v-on:click="requestAuditEdit()"
						outlined
						>Request Edit</v-btn
					>
				</v-col>
			</v-row>
			<v-row
				class="contentRow"
				v-if="
					audit &&
						typeof audit.status !== 'undefined' &&
						audit.editRequest !== null
				"
			>
				<v-col cols="12">
					<h2>An edit request has been sent for this audit</h2>
				</v-col>
				<v-col justify-center cols="12">
					<v-alert dense class="mt-5" type="warning">
						This will delete the pending audit request edit.
					</v-alert>
					<v-btn
						class="mt-2"
						color="red"
						v-on:click="deleteEditRequest()"
						outlined
						>Delete edit request</v-btn
					>
				</v-col>
			</v-row>
			<v-row class="contentRow" v-if="audit">
				<v-col cols="12">
					<h2>Download Audit {{ templateName }} as PDF Document</h2>
				</v-col>
				<v-col cols="12">
					<v-btn
						v-if="audit.status !== undefined"
						color="primary"
						@click="downloadAudit(audit.id)"
						>Download</v-btn
					>
					<v-btn v-else color="primary" @click="downloadAudit(audit.id)"
						>Download</v-btn
					>
				</v-col>
			</v-row>
			<v-row class="contentRow" v-if="audit && audit.history !== null">
				<v-col>
					<h2>Audit Status History</h2>
					<p><i>This is a log of all status changes made to this audit.</i></p>
				</v-col>
				<v-col justify-center cols="12">
					<v-data-table
						theme--
						light
						:headers="statusHeaders"
						:items="audit.history"
						class="light table mx-4 completed-table"
						:footer-props="{
							'items-per-page-options': [5, 10, 15]
						}"
					>
						<template v-slot:item.timestamp="{ item }">
							{{ item.timestamp | moment("DD/MM/YYYY HH:mm:ss") }}
						</template>
						<template v-slot:item.status="{ item }">
							<span
								v-bind:class="{
									'primary--text': item.status == 0,
									'success--text': item.status == 1,
									'warning--text': item.status == 2,
									'error--text': item.status == 3,
								'success--text': item.status == 4
								}"
							>
								{{ status(item.status) }}
							</span>
						</template>
						<template v-slot:item.checklistAnswers="{ index, item }">
							<span
								v-if="
									item.checklistAnswers &&
										JSON.parse(item.checklistAnswers).length > 0
								"
							>
								<span
									v-for="(chk, indx) of JSON.parse(item.checklistAnswers)"
									:key="indx"
								>
									{{ checklist[indx] }}
									<v-icon x-small color="primary" class="float-right" v-if="chk"
										>fas fa-check</v-icon
									>
									<v-icon color="warning" x-small class="float-right" v-if="!chk"
										>far fa-circle</v-icon
									><br />
								</span>
							</span>
							<span v-else>
								<i>N/A</i>
							</span>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
			<!--Temporarily hidden for UX reasons-->
			<v-row class="contentRow secondary" v-if="false">
				<v-col cols="12" class="white--text">
					<h2 class="mb-4">
						Blockchain Status:
						<v-chip
							v-if="audit.BlockchainStatus !== 'Awaiting Validification'"
							color="success"
							label
							dark
							>Validified</v-chip
						>
						<v-chip color="warning" label dark v-else>{{
							audit.BlockchainStatus
						}}</v-chip>
					</h2>
					<p v-if="audit.BlockchainStatus !== 'Awaiting Validification'">
						<i
							>The Audit has been validified by the blockchain. Visit the link
							below to see the block in the blockchain.</i
						>
					</p>
					<p v-else>
						<i
							>The Audit has not yet been validified, and is waiting to be added
							to the blockchain.</i
						>
					</p>
					<v-chip
						v-if="audit.BlockchainStatus !== 'Awaiting Validification'"
						:href="'https://nodes.orixe.tech/blocks/' + audit.BlockchainStatus"
						target="_blank"
						color="blue"
						class="text-decoration-underline"
						label
						dark
						>Go to Block #{{ audit.BlockchainStatus }}
						<v-icon small right>fas fa-external-link-alt</v-icon></v-chip
					>
					<v-chip v-else color="blue" label dark disabled
						>Go to Block<v-icon small right
							>fas fa-external-link-alt</v-icon
						></v-chip
					>
				</v-col>
			</v-row>
			<v-dialog v-model="commentBoxOpen" persistent max-width="600">
				<v-card>
					<v-col>
						<v-card-title>How was your overall experience using the Orixe platform?</v-card-title>
						<v-btn icon :color="platform === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
						<v-btn icon :color="platform === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
						<v-btn icon :color="platform === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
						<v-btn icon :color="platform === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
						<v-btn icon :color="platform === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
					</v-col>
					<v-col>
						<v-card-title>How was is to navigate in the platform?</v-card-title>
						<v-btn icon :color="navigation === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
						<v-btn icon :color="navigation === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
						<v-btn icon :color="navigation === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
						<v-btn icon :color="navigation === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
						<v-btn icon :color="navigation === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
					</v-col>
					<v-col>
						<v-card-title>How was your experience completing the task?</v-card-title>
						<v-btn icon :color="task === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
						<v-btn icon :color="task === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
						<v-btn icon :color="task === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
						<v-btn icon :color="task === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
						<v-btn icon :color="task === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
					</v-col>
					<v-col>
						<v-card-title>Do you have any suggestions for improvement?</v-card-title>
						<v-card-text>
							<!-- Your comment box content goes here -->
							<v-textarea v-model="comment"></v-textarea>
						</v-card-text>
					</v-col>
					<v-card-actions>
						<v-btn @click="submitComment()" color="primary">Submit</v-btn>
						<v-btn @click="commentBoxOpen = false" color="primary">Cancel</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
		<v-row v-else-if="feedback == 1" class="contentRow pr-15 pl-15">
			<v-col cols="12" class="pl-15 pr-15">
				<v-card-actions class="justify-end">
					<v-icon class="pl-1 pr-1" color="primary" @click="cancelFeedback()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
				</v-card-actions>
				<v-img alt="Success Icon" :src="require('../../assets/twemoji/success.svg')" width="70" class="mx-auto my-8" />
				<h2 class="mb-5">Thank You for Your Feedback!</h2>
				<p>We truly appreciate you taking the time to share your thoughts. Your input helps us make Orixe more effective and user-friendly.</p>
				<p>At Orixe, we believe transparency and accountability are essntial for a better future.</p>
				<p>Supply chains impact the environment, human rights, and resources -- but often lack the visibility needed for responsible management.</p>
				<p>Together we're working towards ethical, sustainable supply chains that build trust and drive progress.</p>
				<p>Thank you for being part of this journey!</p>
			</v-col>
			<v-col cols="12" align="center">
				<v-btn class="ma-2 white--text" color="primary" to="/ProductPlan">UPGRADE MY ACCOUNT</v-btn>
			</v-col>
		</v-row>
		<v-dialog v-model="exitDialog" max-width="700">
			<v-card cols="12" class="pa-10">
				<v-card-actions class="justify-end">
					<v-icon class="pl-1 pr-1" color="primary" @click="cancelExit()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
				</v-card-actions>
				<p>"At Orixe, we believe businesses are the world's most influential institutions. Their decisions shape supply chains, 
					communities, and ecosystems, impacting lives and economies. However, the complexity of global supply chains often makes it 
					challenging to ensure ethical practices and minimize environmental harm.</p>
				<p>We believe this challenge can be addressed by combining advanced technology with core values like integrity, accountability, and fairness, 
					enabling organizations to act decisively and effectively."</p>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import LoadingState from "../../consts/LoadingState"
import AuditAPI from "../../api/audit/audit"
import RequestAPI from "../../api/audit/request"
import router from "../../router"
import FilesAPI from "../../api/files/files"
import FileUploaderVue from "../../components/FileUploader.vue"
export default {
	name: "FlowDownAuditDetails",
	components: {
		"file-uploader": FileUploaderVue
	},
	data() {
		return {
			id: 69,
			prevId: null,
			auditData: [],
			audit: null,
			templateName: null,
			editRequest: null,
			recipientName: null,
			senderName: null,
			comment: null,
			requestEditComment: null,
			expiryDateMenu: false,
			newExpiryDate: null,
			statusHeaders: [
				{
					text: "Username",
					value: "username",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Status",
					value: "status",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Comment",
					value: "comment",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Checklist",
					value: "checklistAnswers",
					sortable: false,
					class: "secondary--text"
				}
			],
			checklist: [],
			checklistAnswers: [],
			replacing: null,
			replacedBy: null,
			logo: null,
			confirmationDialog: false,
			selectedStatusId: null,
			auditStatus: null,
			retransmissionsHierarchy: null,
			commentBoxOpen: false,
			navigation: null,
			platform: null,
			task: null,
			isFeedbackGiven: false,
			feedback: 0,
			exitDialog: false,
		}
	},
	mounted() {
		if (isNaN(parseInt(this.$route.params.id))) {
			router.push("/")
		} else {
			this.id = parseInt(this.$route.params.id)
			this.loadAudit()
		}

		this.getFeedbackData()
	},
	methods: {
		getFeedbackData(){
			let currentTime = new Date()
			RequestAPI.getFeedback()
				.then(result => {
					for (let entry of result) {
						if( entry.Module == 2){
							let submittedTime = new Date(entry.SubmitTime)
							let different = Math.floor((currentTime - submittedTime) / (1000 * 60 * 60 * 24))
							if(different < 60){
								this.isFeedbackGiven = true
							}
						}
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadAudit() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditAPI.get(this.id)
				.then(result => {
					this.audit = result
					this.auditData = result.answers
					this.templateName = result.templateName
					this.editRequest = result.editRequest
					this.recipientName = result.recipientName
					this.senderName = result.senderName
					this.comment = result.statusComment
					this.checklist = result.checklist || []
					this.replacing = result.replacing
					this.replacedBy = result.replacedBy
					this.logo = result.logoURL
					this.retransmissionsHierarchy = result.retransmissions_hierarchy
					this.$set(
						this,
						"checklistAnswers",
						result.statusChecklist
							? result.statusChecklist
							: this.checklist.map(() => false)
					)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.auditStatus = result.status
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		renderHierarchy(node, isFirst = true) {
			let html = ""

			// Root node styling (display separately)
			if (isFirst) {
				html += `
				<div style="display: flex; align-items: center; margin-bottom: 10px; margin-top: 10px;">
					<span style="font-size: 16px; font-weight: bold; color: #333; margin-left: 20px; margin-right: 8px;">${this.recipientName}</span>
					<div >
					<span style="border-top: 1px solid #1e7c83; width: 40px; padding-left: 0px;"></span>
					<span style="color: #1e7c83; ">---------&#9658;</span>
					
				</div>
				`
				if(this.retransmissionsHierarchy.children.length==0){
					html += `
				<div style="display: flex; align-items: center; margin-bottom: 10px; margin-top: 10px;">
					<span style="font-size: 16px; font-weight: bold; color: #333; margin-right: 12px;">${this.senderName}</span>
				</div>
				`
				}else{
					html += `
				<div style="display: flex; align-items: center; margin-bottom: 10px; margin-top: 10px;">
					<span style="font-size: 16px; font-weight: bold; color: #333; margin-right: 12px;">${this.senderName}</span>
					<span style="border-top: 1px solid #1e7c83; width: 40px; padding-left: 0px;"></span>
					<span style="color: #1e7c83; ">&#9658;</span>
				</div>
				`
				}

			} else {
				// Non-root node styling (with connectors)
				html += `
				<div style="display: flex; align-items: center; ">
					<span style="border-top: 1px solid #1e7c83; width: 40px; padding-left: 0px;"></span>
					<span style="color: #1e7c83; ">&#9658;</span>
					<span style="font-size: 12px; border: 1px solid #1e7c83; padding: 4px; border-radius: 4px; margin-top: 10px;"><i class="fas fa-tasks" style="color: #1e7c83; "></i></span>
				</div>
				`
			}
			// Render children nodes recursively if they exist
			if (node.children && node.children.length > 0) {
				if(isFirst){
					html += `<div style="border-left: 3px solid #1e7c83; ">`
				}else{
					html += `<div style="border-left: 3px solid #1e7c83; margin-left: 40px;">`
				}
				node.children.forEach((child) => {html += this.renderHierarchy(child, false) })
				html += `</div>`
			}

			return html
		},
		shouldDisplay(question) {
			if (question.type == "spacer") {
				return true
			}
			if (question.visible == true) {
				return true
			}
			return false
		},
		status(id) {
			if (id == 0) {
				return "Pending"
			} else if (id == 1) {
				return "Approved"
			} else if (id == 2) {
				return "Conditionally Approved"
			} else if (id == 3) {
				return "Denied"
			}else if (id == 4) {
				return "Created"
			}
		},
		/* setStatus(statusID) {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditAPI.setStatus(this.id, statusID, this.comment, this.checklistAnswers)
				.then(() => {
					this.loadAudit()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Successfully changed the status!",
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		}, */
		setStatus(statusID) {
			if (this.auditStatus !== statusID) {
				this.selectedStatusId = statusID
				this.confirmationDialog = true 
			}
		},
		confirmStatusChange() { 
			this.confirmationDialog = false 
			
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditAPI.setStatus(this.id, this.selectedStatusId, this.comment, this.checklistAnswers)
				.then(() => {
					this.loadAudit()
					
					setTimeout(()=>{
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
							"Successfully changed the status!",
							{ root: true }
						)
					},1000)
					this.auditStatus = this.selectedStatusId
				})
				.catch(reason => {
					
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
					)
				})
		},
		cancelStatusChange() {
			this.selectedStatusID = null
			this.confirmationDialog = false
		},
		isButtonClicked(statusID) {
			return this.auditStatus === statusID
		},
		requestAuditEdit() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			RequestAPI.addRequestEdit(true, this.id, this.requestEditComment, 0)
				.then(data => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully sent an audit request edit with ID ${data} to ${this.recipientName}`,
						{ root: true }
					)
					this.loadAudit()
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		deleteEditRequest() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			RequestAPI.deleteRequest(this.editRequest)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully deleted audit request edit with ID '${this.editRequest}'`,
						{ root: true }
					)
					this.loadAudit()
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		setNewExpiryDate(value) {
			let ms = this.$moment(value).valueOf()
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditAPI.setExpiry(this.id, ms)
				.then(() => {
					this.expiryDateMenu = false
					this.loadAudit()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Successfully changed the status!",
						{ root: true }
					)
				})
				.catch(reason => {
					this.expiryDateMenu = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		downloadFile(fileID, name) {
			FilesAPI.download("" + fileID, name)
		},
		checkOff(index) {
			this.checklistAnswers[index] = !this.checklistAnswers[index]
				? true
				: false
		},
		downloadAudit(auditID) {
			let name = "audit_"
			name += this.templateName
			if (this.audit && this.audit.status !== "undefined") {
				name += `_${this.senderName}`
			} else {
				name += `_${this.recipientName}`
			}
			name = name.split(" ").join("_")
			AuditAPI.downloadAuditPDF(auditID, name)
		},
		flowDown() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditAPI.flowDown(this.id)
				.then(val => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Successfully created template!",
						{ root: true }
					)
					router.push("/audit/templates/" + val)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		platformComment(selected) {
			this.platform = selected
			this.commentBoxOpen = true
		},
		navigationComment(selected) {
			this.navigation = selected
		},
		taskComment(selected) {
			this.task = selected
		},
		closeCommentBox() {
			this.commentBoxOpen = false
		},
		submitComment() {
			let id = this.$route.params.id
			let submitTime = new Date().toISOString().slice(0, 19).replace("T", " ")
			let module = this.$route.path.split("/")[1]
			
			RequestAPI.submitFeedback(id,submitTime,this.platform,this.navigation,this.task,this.comment,module)
				.then( () => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully submit the feedback`,
						{ root: true }
					)
					this.commentBoxOpen = false
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
			this.commentBoxOpen = false
			this.feedback = 1
		},
		cancelFeedback(){
			this.exitDialog = true
		},
		cancelExit(){
			this.exitDialog = false
			this.$router.push("/")
		},
		getFreeAcc(){
			this.$router.push("/ProductPlan")
		}
	}
}
</script>

<style scoped>
	.denybutton:not(.outlined){
		color: white;
	}
</style>